import { render, staticRenderFns } from "./CartPanda.vue?vue&type=template&id=448d299c&"
import script from "./CartPanda.vue?vue&type=script&lang=js&"
export * from "./CartPanda.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports